import React from 'react';
import styles from './styles.module.css';
import { productCardType, shop } from '@/commonTypes';
import { useTranslations } from 'next-intl';

export default function ProductBadges({ data }: { data?: productCardType | shop }) {
  const tCommon = useTranslations('common');
  return (
    <div className={`${styles.pcard_badges}`}>
      {data?.tag && <span className={`${styles.badge} ${styles.badge_pro}`}>{data?.tag}</span>}
      {data?.discount && (
        <>
          <span className={`${styles.badge} ${styles.badge_sale}`}>{tCommon('discount')}</span>
          {/* <span className={`${styles.badge} ${styles.badge_sale}`}>{data?.discount}</span> */}
        </>
      )}
      {data?.new && <span className={`${styles.badge} ${styles.badge_new}`}>{tCommon('new')}</span>}
      {data?.selected && (
        <span className={`${styles.badge} ${styles.badge_pro}`}>{tCommon('selected')}</span>
      )}
    </div>
  );
}
